/**
 * formItem 枚举类型
 */
export enum YoComponentType {
  Input = 'Input', // 基础输入框
  LabelInput = 'LabelInput', // 带标题的输入框
  Select = 'Select', // 下拉框
  Radio = 'Radio', // 单选框
  DatePicker = 'DatePicker', // 日期选择器
  RangePicker = 'RangePicker', // 日期范围选择器
  BaseText = 'BaseText', // 基础显示框
  Render = 'Render', // 自定义Render组件 适用于外部业务组件
}

export interface YoComponent {
  type: YoComponentType // 组件类型
  [key: string]: string | number | boolean | undefined
}
/**
 * btn 枚举类型
 */
export enum YoBtnType {
  ButtonNormal = 'ButtonNormal', // 常规按钮
  // ButtonCancel = 'ButtonCancel', // 取消按钮
  ButtonAdd = 'ButtonAdd', // 新增按钮，绑定addApi
  ButtonDelete = 'ButtonDelete', // 删除按钮，绑定delApi
  ButtonEdit = 'ButtonEdit', // 编辑按钮，绑定editApi
  ButtonSearch = 'ButtonSearch', // 查询按钮，绑定searchApi
  ButtonReset = 'ButtonReset', // 清空按钮，用于清除筛选框表单的值
  ButtonExport = 'ButtonExport', // 导出按钮
}

export enum ApiList {
  AddApi = 'addApi',
  DelApi = 'delApi',
  SearchApi = 'searchApi',
  EditApi = 'editApi',
}
export const dateFormatter: string[] = ['YYYY-MM-DD']

/**
 * btn base type
 */
export type baseLabelBtnType = '查询' | '取消' | '清空' | '新增' | '添加'

export type YoComponentStringType = keyof typeof YoComponentType

export type baseBtnType = keyof typeof YoBtnType

/**
 * 按钮类型
 */
export type btnBaseListType = {
  label: baseLabelBtnType
  type: baseBtnType
  btnFormAction?: (form: any) => void // 按钮点击回调
  [key: string]: any
}

/**
 * @description 自定义组件类型
 */
export type RenderType = ((c?: Record<string, any>) => React.ReactNode) | React.ReactNode // 自定义外部业务组件类型

export const mergeType = {...YoBtnType, ...YoComponentType} as const

export type combineType = keyof typeof mergeType

export interface RenderComponentIprops extends Omit<baseComponentType, 'type'> {
  type: combineType
}

/**
 * 基础formItem 类型
 */
export interface baseComponentType {
  name: string
  type: YoComponentStringType
  placeholder?: string
  label?: string
  valueText?: string
  render?: RenderType
  [key: string]: any | Record<string, any> | unknown | boolean
  options?: any
  rules?: any[]
}
/**
 * formJson  类型
 */
export interface formJsonType {
  componentList: baseComponentType[]
  btnList?: btnBaseListType[]
}

export type AnyObject = Record<PropertyKey, any>

/**
 * searchJson 类型
 */

export interface searchJsonType {
  componentList: baseComponentType[]
  btnList?: btnBaseListType[]
}
/**
 * searchJson 类型
 */

export interface tableJsonType {
  columns: {key: string; title: string}[]
  dataSource?: any[]
}

/**
 * api 类型
 */
export type schemaApiType = {
  addApi?: string
  delApi?: string
  searchApi?: string
  editApi?: string
  exportApi?: string
}

export interface SchemaType {
  addJson?: baseComponentType[]
  editJson?: baseComponentType[]
  searchJson: baseComponentType[]
  apiList?: schemaApiType
  tableJson: tableJsonType
  children?: any
}
/**
 * @description 请求types
 */

export enum businessEnum {
  yomi = 1,
  zhuiya = 2,
  bos = 3,
  hgame = 4,
}

export type enumsBusType = keyof typeof businessEnum
